export default __webpack_public_path__ + "static/media/yardi-logo.4411f628.svg";